export default __webpack_public_path__ + "da17cf014cb3bcf853a2b3f4743a79c8.png";